export default __webpack_public_path__ + "static/media/arm-right-back.cb1b329d.png";